export default __webpack_public_path__ + "static/media/essentials-collection_mobile.301c9eb8.png";